var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalizarApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#98A6AD",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 16 1 C 13.802666 1 12 2.8026661 12 5 L 12 45 C 12 47.197334 13.802666 49 16 49 L 34 49 C 36.197334 49 38 47.197334 38 45 L 38 5 C 38 2.8026661 36.197334 1 34 1 L 16 1 z M 16 3 L 22 3 C 22 3.552 22.448 4 23 4 L 27 4 C 27.552 4 28 3.552 28 3 L 34 3 C 35.116666 3 36 3.8833339 36 5 L 36 45 C 36 46.116666 35.116666 47 34 47 L 16 47 C 14.883334 47 14 46.116666 14 45 L 14 5 C 14 3.8833339 14.883334 3 16 3 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizarApp);
export default __webpack_public_path__ + "static/media/personalizarApp.bf0eec93cba7a60ebed9d16b11512cd4.svg";
export { ForwardRef as ReactComponent };